exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clear-margin {\n  margin-top: 0; }\n\n.main-height {\n  min-height: 800px; }\n\n.nav-item {\n  background-color: #ffb946; }\n\n.nav-link-item {\n  padding-left: 2rem !important; }\n\na.nav-link {\n  background-color: #3c4144 !important; }\n\na.nav-link.active {\n  margin-left: 4px;\n  background-color: #231f20 !important; }\n\ni {\n  font-size: 1rem !important;\n  font-weight: 800 !important;\n  font-style: bold;\n  font-stretch: normal;\n  color: #fff !important; }\n\na {\n  font-weight: 600 !important;\n  font-style: normal;\n  font-stretch: normal; }\n\n.pointer-nav {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/layouts/sidebar/sidebar.component.scss
// module id = ../../../../../src/app/layouts/sidebar/sidebar.component.scss
// module chunks = main